<template>
	<div class="dashboard profil connected-page">
		<div class="container">
			<header id="header">
				<div class="sscontainer">
          <div class="menu-block container-logo">
            <logo-lien-header></logo-lien-header>
          </div>
					<div class="menu-block">
            <div class="menu-icons">
              <menu-header-profil v-if="userSelected"></menu-header-profil>
              <menu-header-chat></menu-header-chat>
            </div>
            <div class="menu-icons" style="padding: 8px">
              <profile-picture></profile-picture>
              <div class="menu-name">{{ user ? user.first_name + ' ' + user.name : '' }}</div>
              <menu-header-signout></menu-header-signout>
            </div>
					</div>
          <profile-picture></profile-picture>
          <menu-header-chat></menu-header-chat>
				</div>
			</header>
			<main id="main" class="dashboard-main">
        <dashboard-sidebard :extra-matching="extra_matching" :is-pro="isPro" :user="user"/>
				<div class="dashboard-content">
					<advert-bar-pro v-if="user && user.id && isPro && !advertBarIgnoreList.includes($route.name)" :user="user" />
          <div class="loader-wrapper" style="height: 250px" v-if="!user || resetting"><div class="loader big"></div></div>
          <router-view v-else @extra:matching="v => extra_matching = v" :is-pro="isPro" :user="user"></router-view>
				</div>
			</main>
			<clc-footer/>
		</div>
		<add2homescreen></add2homescreen>
	</div>
</template>

<script>
import * as websocket from '@/websocket'
import notifAudio from '@/components/mixins/notifAudio'
import { eventBus, registrationHelpers } from '@/main'

export default {
  name: 'dashboard-layout',
  data: () => ({
    userSelected: {},
    extra_matching: -1,
    user: {},
    resetting: false,
    advertBarIgnoreList: [
      'DashboardProHomes',
      'DashboardProReports',
      'DashboardProInvitation',
      'DashboardPreviewAdvert',
      'DashboardParameters',
      'DashboardProfile',
      'DashboardSupport',
      'DashboardOwnerSupport',
      'DashboardSupportTicket',
      'DashboardManagerSupport',
      'DashboardManagerSupportTicket',
      'DashboardEdition',
      'DashboardAccount',
      'DashboardAccountEdition',
    ],
  }),
  computed: {
    isPro() {
      return this.user && !registrationHelpers.userTypes.is(this.user, 'coloc')
    },
  },
  mixins: [notifAudio],
  mounted() {
    websocket.open(eventBus)
    registrationHelpers.fetchDataUser(this, () => {
      // Check if user_type is allowed
      if (this.$route.params.user_type) {
        const user = this.user
        if ((this.$route.params.user_type === 'users' && (user.type & registrationHelpers.userTypes.coloc) === 0) ||
					(this.$route.params.user_type === 'proprietaire' && (user.type & registrationHelpers.userTypes.proprio) === 0) ||
          (this.$route.params.user_type === 'manager' && (user.type & registrationHelpers.userTypes.manager) === 0) ||
					(this.$route.params.user_type === 'agent' && (user.type & registrationHelpers.userTypes.agent) === 0)) {
          const route = {}
          if (this.$route.name) route.name = this.$route.name
          else route.path = this.$route.fullPath
          route.query = { ...this.$route.query }
          route.params = { ...this.$route.params }
          route.params.user_type = registrationHelpers.userTypes.baseURL(user)
          this.$router.push(route)
        }
      }
    })
    eventBus.$on('userReset', this.onUserReset)
    eventBus.$on('ownerChanged', this.onOwnerChanged)

    function onConversationsAPIReady() {
      console.log(`HubSpot Conversations API: ${window.HubSpotConversations}`)
      window.HubSpotConversations.widget.load()
    }
    window.hsConversationsSettings = {
      loadImmediately: false,
      // inlineEmbedSelector: '#some-id',
      enableWidgetCookieBanner: false,
      disableAttachment: true,
    }
    const script = document.createElement('script')
    script.src = 'https://js-eu1.hs-scripts.com/25924500.js'
    document.body.appendChild(script)
    script.addEventListener('load', () => {
      if (window.HubSpotConversations) {
        onConversationsAPIReady()
      } else {
        window.hsConversationsOnReady = [onConversationsAPIReady]
      }
    })
  },
  beforeDestroy() {
    websocket.close()
    eventBus.$off('ownerChanged', this.onOwnerChanged)
    eventBus.$off('userReset', this.onUserReset)
  },
  methods: {
    onUserReset() {
      this.resetting = true
      registrationHelpers.fetchDataUser(this, () => {
        this.resetting = false
      })
    },
    onOwnerChanged(event) {
      if (event.owner && event.owner.id === this.user.id) {
        this.user = event.owner
      }
    },
  },
  watch: {
    '$route.name'() {
      this.extra_matching = -1
    },
    '$route.query.home_id'() {
      this.extra_matching = -1
    },
  },
  components: {
    add2homescreen: require('@/components/common/Add2Homescreen').default,
    AdvertBarPro: require('@/components/common/DashboardAdvertBarPro').default,
  },
}
</script>

<style lang="scss">

.dashboard {
  background-color: rgba(252, 252, 252, 1);
  width: 100%;
  min-height: 100%;
  flex-direction: column;
  flex-wrap: nowrap;
  row-gap: 0px;
  display: flex;
  box-sizing: border-box;

  .container {
    padding: 0;
  }
}

main#main.dashboard-main {
  display: flex;
  min-height: 80px;
  flex-direction: row;
  column-gap: 80px;
  flex-grow: 0;
  flex-shrink: 0;
  width: 100%;
  margin: 0;
  padding: 0;

  @media #{$desktop-small} {
    column-gap: 40px;
  }

  .dashboard-content {
    margin: 40px 80px 0px 0px;
    display: flex;
    flex-grow: 1;
    row-gap: 24px;
    justify-content: flex-start;
    min-width: 375px;
    width: 375px;
    height: max-content;
    flex-direction: column;

    @media #{$desktop-small} {
      margin-right: 16px;
    }

    @media #{$tablet} {
      margin: 0;
    }

    @media #{$phone} {
      width: 100vw;
      min-width: 100vw;
      max-width: 100vw;
    }

    .dashboard-page {
      display: flex;
      flex-direction: column;
      row-gap: 24px;
    }

    .dashboard-card {
      background: white;
      padding: 40px;

      @media #{$desktop-small} {
        padding: 24px;
      }
    }

    .collapsible {
      background: white;
      padding: 16px;

      @media #{$desktop-small} {
        padding: 8px;
      }
    }

    .dashboard-blocks {
      display: flex;
      flex-direction: column;
      row-gap: 40px;
    }

    .dashboard-container {
      margin-top: 0px;
      max-width: initial;
    }
  }

  @media #{$tablet} {
    min-height: calc(100vh - 64px);

    .dashboard-sidebar {
      display: none;
    }

    .dashboard-content {
      margin: 0;
      padding: 24px 12px;

      .dashboard-page {
        row-gap: 16px;

        h2 {
          text-align: center;
        }
      }

      .dashboard-card, .collapsible {
        padding: 16px;
      }
    }
  }

  @media #{$phone} {
    width: 100vw;
    min-width: 100vw;
    max-width: 100vw;
    column-gap: 0px;

    .dashboard-content {
      min-width: 100vw;
      width: 100vw;
    }

    .dashboard-content .dashboard-card {
      padding: 16px 0;
    }

    .dashboard-content .collapsible {
      padding: 16px 0;
    }
  }
}

.left-sidebar {
  margin: 40px 0px 0px 80px;

  @media #{$desktop-small} {
    margin-left: 16px;
  }

  display: grid;
  grid-auto-rows: minmax(max-content, 40px);
  grid-template-columns: repeat(1, minmax(max-content, auto));
  grid-auto-flow: row;
  min-width: 135px;
  height: max-content;
  width: auto;

  .un-tab-bord {
    > div {
      padding: 8px;
      cursor: pointer;
      box-sizing: border-box;
      margin: 0;

      > .sscontainer {
        background: transparent;
        padding: 0;
      }
    }
  }
}

.dashboard-content {
	.loader-wrapper {
		width: 100%;
		height: 50vh;
		min-height: 200px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

  .block-loader-wrapper {
    width: 100%;
    height: 50px;
    min-height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.my-subscription-info .red-btn {
	color: $red;
	border-color: $red;

	&:hover {
		color: #FFF;
		background: $red;
	}
}
</style>
